<template>
  <div :class="classes.content">
    <div :class="[classes.cardContent, 'win-draw-win']">
      <div :class="classes.marketOptions">
        <WinOptionBranded
          :key="key1"
          :stagger="0"
          :class="classes.marketOption"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[0]"
          :competitor="competitors[0]"
          :textWidth="useTeamIcons ? 58 : 95"
          :isLeft="true"
          :disableBadges="!useTeamIcons"
          homeOrAwayTeam="home"
          alignbadge="left"
        />
        <WinOptionBranded
          :key="key2"
          :eventId="eventId"
          :isDraw="true"
          :stagger="1"
          :class="[classes.marketOption, 'draw']"
          :optionId="ftrMarkets[0].options[1]"
          :textWidth="58"
        />
        <WinOptionBranded
          :key="key3"
          :stagger="2"
          :class="classes.marketOption"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[2]"
          :competitor="competitors[1]"
          :textWidth="useTeamIcons ? 58 : 95"
          :disableBadges="!useTeamIcons"
          homeOrAwayTeam="away"
          alignbadge="right"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, ComputedRef, defineComponent, ref } from "vue";
import WinOptionBranded from "../../../WinOptionMobileBranded.vue";
import {
  composeHomeAwayOptions,
  composeEventCompetitors
} from "@fresh8/ad-data-composition/src/betData";

import { SportCompetitor } from "@fresh8/types/src/betData";
import { injectTeamColors } from "../../../../lib/teamBranding";
import { useCenterMobileLeaderboard } from "../../../../hooks/useLayout";

const useStyles = createUseStyles({
  //@ts-ignore
  content: props => ({
    display: "flex",
    flexDirection: "row",
    padding: "4px",
    height: "inherit",

    ...props.mlbCenterStyles
  }),
  cardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",

    "& .team-jersey": {
      maxHeight: "30px"
    }
  },
  marketOptions: {
    flex: 1,
    display: "flex",
    width: "100%",
    maxHeight: "34px"
  },
  marketOption: {
    "&.draw": {
      width: "60px",
      paddingLeft: "4px",
      paddingRight: "4px",
      "&.button": {
        backgroundColor: "#D3D5E1"
      }
    },
    "&.odds-text .button-text": {
      width: "60px",
      paddingLeft: "4px",
      paddingRight: "4px",
      minWidth: "50px",
      textAlign: "center"
    },
    "&:first-of-type": {
      flex: "1 1 36%"
    },
    "&:last-of-type": {
      flex: "1 1 36%"
    },

    "& .meta-text": {
      fontSize: "7px"
    },
    "& .odds-text": {
      fontSize: "12px"
    },

    "& a": {
      padding: "1px 0"
    }
  }
});

export default defineComponent({
  name: "MobileLeaderboardWDW",
  components: {
    WinOptionBranded
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const marketId = ref([props.marketId]);

    const mlbCenterStyles = useCenterMobileLeaderboard();
    const computedStyles = computed(() => ({
      mlbCenterStyles: mlbCenterStyles.value
    }));
    const classes = useStyles(computedStyles);
    const ftrMarkets = composeHomeAwayOptions(marketId);
    const competitors = composeEventCompetitors(props.eventId) as ComputedRef<
      SportCompetitor[]
    >;

    const teamColorsContext = injectTeamColors();

    const useTeamIcons = computed(
      () => teamColorsContext.teamIconsAvailable.value
    );

    return {
      useTeamIcons,
      competitors,
      classes,
      ftrMarkets
    };
  },
  data() {
    return {
      key1: Math.random(),
      key2: Math.random(),
      key3: Math.random()
    };
  },
  methods: {
    syncUpdate() {
      this.key1 = Math.random();
      this.key2 = Math.random();
      this.key3 = Math.random();
    }
  }
});
</script>

<style></style>
